import { DateStringValue } from '@mantine/dates';
import dayjs from 'dayjs';

export const handleNextMonthClick = (
  date: DateStringValue,
  setDate: (date: DateStringValue) => void
): void => {
  setDate(dayjs(date).add(1, 'month').startOf('month').format('YYYY-MM-DD'));
};
